// All countries with their ISO code and phone dial code (without "+").
// Sorted by name. Tanzania is the default selection on the Home page.
const countries = [
  { name: 'Afghanistan', iso: 'af', dial: '93' },
  { name: 'Albania', iso: 'al', dial: '355' },
  { name: 'Algeria', iso: 'dz', dial: '213' },
  { name: 'American Samoa', iso: 'as', dial: '1684' },
  { name: 'Andorra', iso: 'ad', dial: '376' },
  { name: 'Angola', iso: 'ao', dial: '244' },
  { name: 'Anguilla', iso: 'ai', dial: '1264' },
  { name: 'Antigua and Barbuda', iso: 'ag', dial: '1268' },
  { name: 'Argentina', iso: 'ar', dial: '54' },
  { name: 'Armenia', iso: 'am', dial: '374' },
  { name: 'Aruba', iso: 'aw', dial: '297' },
  { name: 'Australia', iso: 'au', dial: '61' },
  { name: 'Austria', iso: 'at', dial: '43' },
  { name: 'Azerbaijan', iso: 'az', dial: '994' },
  { name: 'Bahamas', iso: 'bs', dial: '1242' },
  { name: 'Bahrain', iso: 'bh', dial: '973' },
  { name: 'Bangladesh', iso: 'bd', dial: '880' },
  { name: 'Barbados', iso: 'bb', dial: '1246' },
  { name: 'Belarus', iso: 'by', dial: '375' },
  { name: 'Belgium', iso: 'be', dial: '32' },
  { name: 'Belize', iso: 'bz', dial: '501' },
  { name: 'Benin', iso: 'bj', dial: '229' },
  { name: 'Bermuda', iso: 'bm', dial: '1441' },
  { name: 'Bhutan', iso: 'bt', dial: '975' },
  { name: 'Bolivia', iso: 'bo', dial: '591' },
  { name: 'Bosnia and Herzegovina', iso: 'ba', dial: '387' },
  { name: 'Botswana', iso: 'bw', dial: '267' },
  { name: 'Brazil', iso: 'br', dial: '55' },
  { name: 'British Virgin Islands', iso: 'vg', dial: '1284' },
  { name: 'Brunei', iso: 'bn', dial: '673' },
  { name: 'Bulgaria', iso: 'bg', dial: '359' },
  { name: 'Burkina Faso', iso: 'bf', dial: '226' },
  { name: 'Burundi', iso: 'bi', dial: '257' },
  { name: 'Cambodia', iso: 'kh', dial: '855' },
  { name: 'Cameroon', iso: 'cm', dial: '237' },
  { name: 'Canada', iso: 'ca', dial: '1' },
  { name: 'Cape Verde', iso: 'cv', dial: '238' },
  { name: 'Cayman Islands', iso: 'ky', dial: '1345' },
  { name: 'Central African Republic', iso: 'cf', dial: '236' },
  { name: 'Chad', iso: 'td', dial: '235' },
  { name: 'Chile', iso: 'cl', dial: '56' },
  { name: 'China', iso: 'cn', dial: '86' },
  { name: 'Colombia', iso: 'co', dial: '57' },
  { name: 'Comoros', iso: 'km', dial: '269' },
  { name: 'Congo', iso: 'cg', dial: '242' },
  { name: 'Congo (DRC)', iso: 'cd', dial: '243' },
  { name: 'Cook Islands', iso: 'ck', dial: '682' },
  { name: 'Costa Rica', iso: 'cr', dial: '506' },
  { name: "Côte d'Ivoire", iso: 'ci', dial: '225' },
  { name: 'Croatia', iso: 'hr', dial: '385' },
  { name: 'Cuba', iso: 'cu', dial: '53' },
  { name: 'Curaçao', iso: 'cw', dial: '599' },
  { name: 'Cyprus', iso: 'cy', dial: '357' },
  { name: 'Czech Republic', iso: 'cz', dial: '420' },
  { name: 'Denmark', iso: 'dk', dial: '45' },
  { name: 'Djibouti', iso: 'dj', dial: '253' },
  { name: 'Dominica', iso: 'dm', dial: '1767' },
  { name: 'Dominican Republic', iso: 'do', dial: '1809' },
  { name: 'Ecuador', iso: 'ec', dial: '593' },
  { name: 'Egypt', iso: 'eg', dial: '20' },
  { name: 'El Salvador', iso: 'sv', dial: '503' },
  { name: 'Equatorial Guinea', iso: 'gq', dial: '240' },
  { name: 'Eritrea', iso: 'er', dial: '291' },
  { name: 'Estonia', iso: 'ee', dial: '372' },
  { name: 'Eswatini', iso: 'sz', dial: '268' },
  { name: 'Ethiopia', iso: 'et', dial: '251' },
  { name: 'Falkland Islands', iso: 'fk', dial: '500' },
  { name: 'Faroe Islands', iso: 'fo', dial: '298' },
  { name: 'Fiji', iso: 'fj', dial: '679' },
  { name: 'Finland', iso: 'fi', dial: '358' },
  { name: 'France', iso: 'fr', dial: '33' },
  { name: 'French Guiana', iso: 'gf', dial: '594' },
  { name: 'French Polynesia', iso: 'pf', dial: '689' },
  { name: 'Gabon', iso: 'ga', dial: '241' },
  { name: 'Gambia', iso: 'gm', dial: '220' },
  { name: 'Georgia', iso: 'ge', dial: '995' },
  { name: 'Germany', iso: 'de', dial: '49' },
  { name: 'Ghana', iso: 'gh', dial: '233' },
  { name: 'Gibraltar', iso: 'gi', dial: '350' },
  { name: 'Greece', iso: 'gr', dial: '30' },
  { name: 'Greenland', iso: 'gl', dial: '299' },
  { name: 'Grenada', iso: 'gd', dial: '1473' },
  { name: 'Guadeloupe', iso: 'gp', dial: '590' },
  { name: 'Guam', iso: 'gu', dial: '1671' },
  { name: 'Guatemala', iso: 'gt', dial: '502' },
  { name: 'Guinea', iso: 'gn', dial: '224' },
  { name: 'Guinea-Bissau', iso: 'gw', dial: '245' },
  { name: 'Guyana', iso: 'gy', dial: '592' },
  { name: 'Haiti', iso: 'ht', dial: '509' },
  { name: 'Honduras', iso: 'hn', dial: '504' },
  { name: 'Hong Kong', iso: 'hk', dial: '852' },
  { name: 'Hungary', iso: 'hu', dial: '36' },
  { name: 'Iceland', iso: 'is', dial: '354' },
  { name: 'India', iso: 'in', dial: '91' },
  { name: 'Indonesia', iso: 'id', dial: '62' },
  { name: 'Iran', iso: 'ir', dial: '98' },
  { name: 'Iraq', iso: 'iq', dial: '964' },
  { name: 'Ireland', iso: 'ie', dial: '353' },
  { name: 'Israel', iso: 'il', dial: '972' },
  { name: 'Italy', iso: 'it', dial: '39' },
  { name: 'Jamaica', iso: 'jm', dial: '1876' },
  { name: 'Japan', iso: 'jp', dial: '81' },
  { name: 'Jordan', iso: 'jo', dial: '962' },
  { name: 'Kazakhstan', iso: 'kz', dial: '7' },
  { name: 'Kenya', iso: 'ke', dial: '254' },
  { name: 'Kiribati', iso: 'ki', dial: '686' },
  { name: 'Kosovo', iso: 'xk', dial: '383' },
  { name: 'Kuwait', iso: 'kw', dial: '965' },
  { name: 'Kyrgyzstan', iso: 'kg', dial: '996' },
  { name: 'Laos', iso: 'la', dial: '856' },
  { name: 'Latvia', iso: 'lv', dial: '371' },
  { name: 'Lebanon', iso: 'lb', dial: '961' },
  { name: 'Lesotho', iso: 'ls', dial: '266' },
  { name: 'Liberia', iso: 'lr', dial: '231' },
  { name: 'Libya', iso: 'ly', dial: '218' },
  { name: 'Liechtenstein', iso: 'li', dial: '423' },
  { name: 'Lithuania', iso: 'lt', dial: '370' },
  { name: 'Luxembourg', iso: 'lu', dial: '352' },
  { name: 'Macau', iso: 'mo', dial: '853' },
  { name: 'Madagascar', iso: 'mg', dial: '261' },
  { name: 'Malawi', iso: 'mw', dial: '265' },
  { name: 'Malaysia', iso: 'my', dial: '60' },
  { name: 'Maldives', iso: 'mv', dial: '960' },
  { name: 'Mali', iso: 'ml', dial: '223' },
  { name: 'Malta', iso: 'mt', dial: '356' },
  { name: 'Marshall Islands', iso: 'mh', dial: '692' },
  { name: 'Martinique', iso: 'mq', dial: '596' },
  { name: 'Mauritania', iso: 'mr', dial: '222' },
  { name: 'Mauritius', iso: 'mu', dial: '230' },
  { name: 'Mayotte', iso: 'yt', dial: '262' },
  { name: 'Mexico', iso: 'mx', dial: '52' },
  { name: 'Micronesia', iso: 'fm', dial: '691' },
  { name: 'Moldova', iso: 'md', dial: '373' },
  { name: 'Monaco', iso: 'mc', dial: '377' },
  { name: 'Mongolia', iso: 'mn', dial: '976' },
  { name: 'Montenegro', iso: 'me', dial: '382' },
  { name: 'Montserrat', iso: 'ms', dial: '1664' },
  { name: 'Morocco', iso: 'ma', dial: '212' },
  { name: 'Mozambique', iso: 'mz', dial: '258' },
  { name: 'Myanmar', iso: 'mm', dial: '95' },
  { name: 'Namibia', iso: 'na', dial: '264' },
  { name: 'Nauru', iso: 'nr', dial: '674' },
  { name: 'Nepal', iso: 'np', dial: '977' },
  { name: 'Netherlands', iso: 'nl', dial: '31' },
  { name: 'New Caledonia', iso: 'nc', dial: '687' },
  { name: 'New Zealand', iso: 'nz', dial: '64' },
  { name: 'Nicaragua', iso: 'ni', dial: '505' },
  { name: 'Niger', iso: 'ne', dial: '227' },
  { name: 'Nigeria', iso: 'ng', dial: '234' },
  { name: 'North Korea', iso: 'kp', dial: '850' },
  { name: 'North Macedonia', iso: 'mk', dial: '389' },
  { name: 'Northern Mariana Islands', iso: 'mp', dial: '1670' },
  { name: 'Norway', iso: 'no', dial: '47' },
  { name: 'Oman', iso: 'om', dial: '968' },
  { name: 'Pakistan', iso: 'pk', dial: '92' },
  { name: 'Palau', iso: 'pw', dial: '680' },
  { name: 'Palestine', iso: 'ps', dial: '970' },
  { name: 'Panama', iso: 'pa', dial: '507' },
  { name: 'Papua New Guinea', iso: 'pg', dial: '675' },
  { name: 'Paraguay', iso: 'py', dial: '595' },
  { name: 'Peru', iso: 'pe', dial: '51' },
  { name: 'Philippines', iso: 'ph', dial: '63' },
  { name: 'Poland', iso: 'pl', dial: '48' },
  { name: 'Portugal', iso: 'pt', dial: '351' },
  { name: 'Puerto Rico', iso: 'pr', dial: '1787' },
  { name: 'Qatar', iso: 'qa', dial: '974' },
  { name: 'Réunion', iso: 're', dial: '262' },
  { name: 'Romania', iso: 'ro', dial: '40' },
  { name: 'Russia', iso: 'ru', dial: '7' },
  { name: 'Rwanda', iso: 'rw', dial: '250' },
  { name: 'Saint Kitts and Nevis', iso: 'kn', dial: '1869' },
  { name: 'Saint Lucia', iso: 'lc', dial: '1758' },
  { name: 'Saint Vincent and the Grenadines', iso: 'vc', dial: '1784' },
  { name: 'Samoa', iso: 'ws', dial: '685' },
  { name: 'San Marino', iso: 'sm', dial: '378' },
  { name: 'São Tomé and Príncipe', iso: 'st', dial: '239' },
  { name: 'Saudi Arabia', iso: 'sa', dial: '966' },
  { name: 'Senegal', iso: 'sn', dial: '221' },
  { name: 'Serbia', iso: 'rs', dial: '381' },
  { name: 'Seychelles', iso: 'sc', dial: '248' },
  { name: 'Sierra Leone', iso: 'sl', dial: '232' },
  { name: 'Singapore', iso: 'sg', dial: '65' },
  { name: 'Sint Maarten', iso: 'sx', dial: '1721' },
  { name: 'Slovakia', iso: 'sk', dial: '421' },
  { name: 'Slovenia', iso: 'si', dial: '386' },
  { name: 'Solomon Islands', iso: 'sb', dial: '677' },
  { name: 'Somalia', iso: 'so', dial: '252' },
  { name: 'South Africa', iso: 'za', dial: '27' },
  { name: 'South Korea', iso: 'kr', dial: '82' },
  { name: 'South Sudan', iso: 'ss', dial: '211' },
  { name: 'Spain', iso: 'es', dial: '34' },
  { name: 'Sri Lanka', iso: 'lk', dial: '94' },
  { name: 'Sudan', iso: 'sd', dial: '249' },
  { name: 'Suriname', iso: 'sr', dial: '597' },
  { name: 'Sweden', iso: 'se', dial: '46' },
  { name: 'Switzerland', iso: 'ch', dial: '41' },
  { name: 'Syria', iso: 'sy', dial: '963' },
  { name: 'Taiwan', iso: 'tw', dial: '886' },
  { name: 'Tajikistan', iso: 'tj', dial: '992' },
  { name: 'Tanzania', iso: 'tz', dial: '255' },
  { name: 'Thailand', iso: 'th', dial: '66' },
  { name: 'Timor-Leste', iso: 'tl', dial: '670' },
  { name: 'Togo', iso: 'tg', dial: '228' },
  { name: 'Tonga', iso: 'to', dial: '676' },
  { name: 'Trinidad and Tobago', iso: 'tt', dial: '1868' },
  { name: 'Tunisia', iso: 'tn', dial: '216' },
  { name: 'Turkey', iso: 'tr', dial: '90' },
  { name: 'Turkmenistan', iso: 'tm', dial: '993' },
  { name: 'Turks and Caicos Islands', iso: 'tc', dial: '1649' },
  { name: 'Tuvalu', iso: 'tv', dial: '688' },
  { name: 'Uganda', iso: 'ug', dial: '256' },
  { name: 'Ukraine', iso: 'ua', dial: '380' },
  { name: 'United Arab Emirates', iso: 'ae', dial: '971' },
  { name: 'United Kingdom', iso: 'gb', dial: '44' },
  { name: 'United States', iso: 'us', dial: '1' },
  { name: 'Uruguay', iso: 'uy', dial: '598' },
  { name: 'US Virgin Islands', iso: 'vi', dial: '1340' },
  { name: 'Uzbekistan', iso: 'uz', dial: '998' },
  { name: 'Vanuatu', iso: 'vu', dial: '678' },
  { name: 'Vatican City', iso: 'va', dial: '39' },
  { name: 'Venezuela', iso: 've', dial: '58' },
  { name: 'Vietnam', iso: 'vn', dial: '84' },
  { name: 'Yemen', iso: 'ye', dial: '967' },
  { name: 'Zambia', iso: 'zm', dial: '260' },
  { name: 'Zimbabwe', iso: 'zw', dial: '263' },
];

export const DEFAULT_COUNTRY = countries.find((c) => c.iso === 'tz');

export default countries;
